module.exports = __webpack_public_path__ + "static/media/Contact - Pin.64891e7c.svg";